import { getRandomInt } from '../../../lib/utilityFunctions';
import { ITEMS_IN_ROUND, ITEMS_IN_35_ROUND, G35_LEVELS_START_INDEX } from '../data/constants';

/**
 * This CurriculumManager is a leftover from the legacy code of the original MarkMyWords
 * In this Sloppy Scrolls iteration, it is used to load curriculum JSON into a reducer,
 * and track user's progress in terms of which items have been seen already in a level
 */

class CurriculumManager {
  constructor() {
    this.curriculum = {}; // Curriculum JSON
    this.onboarding = [];
    this.standardSet = []; // Current bank of standard items
    this.positionInContent = 0;
  }

  /**
   * Sets the curriculum reference to the loaded data.
   *
   * @param {object} curriculumJson
   */
  loadCurriculum(curriculumJson) {
    this.curriculum = curriculumJson;
    // Initially populate the currentStandardSet with level 1's data
    this.populateOnboarding();
    this.populateStandardSet(1);
  }

  getLevelCount() {
    return Object.keys(this.curriculum).length - 1;
  }

  /**
   * Prepares the ONBOARDING Items for use.
   */
  populateOnboarding() {
    const data = this.curriculum.onboarding.slice();
    this.onboarding = data;
  }

  /**
   * Creates a set of standard Items according to the level.
   *
   * Level 1: Fake Words
   * Level 2: Syntax Errors
   * Level 3: Close Inconsistencies
   * Level 4: Far Inconsistences
   *
   * @param {number} level
   * @param {number} positionInContent - if there are 12 FAKEWORD content passages, this indicates the eg 10th one
   */
  populateStandardSet(level, positionInContent) {
    const data = this.curriculum[level].slice();

    const isG35Level = level >= G35_LEVELS_START_INDEX + 1;
    const itemsInRound = isG35Level ?
      ITEMS_IN_35_ROUND :
      ITEMS_IN_ROUND;

    // Iterate through data to obtain random Items
    this.standardSet = []; // reset the standard set so we don't overfill it with extraneous nonsense.
    const allowedIndices = [];
    const fillerIndices = [];
    let startingIndex = null;
    this.positionInContent = positionInContent % data.length;
    for (let i = 0; i < data.length; i++) {
      allowedIndices.push(i);
      if (i >= this.positionInContent && startingIndex === null) {
        startingIndex = allowedIndices.length - 1;
      }
    }
    if (startingIndex === null) {
      startingIndex = 0;
    }

    for (let i = 0; i < itemsInRound; ++i) {
      let dataIndex;
      if (this.standardSet.length < allowedIndices.length) {
        // In this case we have more than enough unmastered items to fill a full round
        // pull a random element from allowed indices and note its value
        const currentIndex = (startingIndex + i) % allowedIndices.length;
        dataIndex = allowedIndices[currentIndex];
        // then remove that element from the list of allowed indices
      } else {
        // we have no more items that the player hasn't already seen. Let's just throw in some filler.
        // pull a random filler element...
        const randIndex = getRandomInt(0, fillerIndices.length);
        dataIndex = fillerIndices[randIndex];
        // ...then remove it from the list so we don't see it multiple times.
        fillerIndices.splice(randIndex, 1);
      }

      this.standardSet.push({
        ...data[dataIndex],
        positionInContent: dataIndex,
      });
    }
  }

  /**
   * For accessing the currentStandardSet outside
   * of the CurriculumManager.
   *
   * @return {array of objects} currentStandardSet
   */
  getStandardSet() {
    return this.standardSet;
  }

  /**
   * Returns the appropriate onboarding Item according to the type of
   * error the user is about to encounter.
   */
  getOnboarding() {
    return this.onboarding;
  }
}

export default CurriculumManager;
